import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { AppSettingsService } from '../app-settings/app-settings.service';
import { first } from 'rxjs';

export function AppInitializerTranslateFactory(
  translate: TranslateService,
  injector: Injector,
  appSettings: AppSettingsService,
) {
  return () =>
    new Promise<any>((resolve: any) => {
      const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

      appSettings.Settings.pipe(first()).subscribe(() => {
        locationInitialized.then(() => {
          translate.use('').subscribe({
            next: () => {
              resolve(null);
            },
            error: err => {
              resolve(null);
            },
            complete: () => {
              resolve(null);
            },
          });
        });
      });
    });
}